export const isEmpty = (val) => {
  if (val == null) return true;

  if (Array.isArray(val) || typeof val === 'string') {
    return val.length === 0;
  }
  if (val instanceof Map || val instanceof Set) {
    return val.size === 0;
  }
  // plain object
  if (Object.getPrototypeOf(val) === Object.prototype) {
    return Object.keys(val).length === 0;
  }

  return false;
};

export const isNotEmpty = (val) => !isEmpty(val);
